import {GenerateJWTToken} from "../helper";

/**
 * @description 4me oauth config and connect generator
 * @returns     object
 * @author      Onur DOGUCU
 */
export async function oauthGenerator(payload) {
    let oauthUrlData = await GenerateJWTToken(payload);
    return oauthUrlData.data ? oauthUrlData.data : "";
}
